// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './style/reset.css'
import 'swiper/dist/css/swiper.css';

Vue.config.productionTip = false;

Vue.directive('document_click', {
  bind: function (el, binding) {
    document.addEventListener('click',binding.value,false);
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js